import React, { useState } from 'react';

function StepEight({ formData, onNext }) {
    const [vaccinations, setVaccinations] = useState(formData.vaccinations || []);
    const [otherVaccination, setOtherVaccination] = useState(formData.otherVaccination || '');
    const [error, setError] = useState('');

    const vaccinationOptions = [
        'Tetanus',
        'Hepatitis B',
        'MMR (Measles, Mumps, Rubella)',
        'COVID-19',
        'TB (BCG)',
        'Other',
        'None of the above' // ✅ Exclusive option
    ];

    const toggleVaccination = (label) => {
        if (label === 'None of the above') {
            // Selecting "None of the above" clears all others
            setVaccinations(['None of the above']);
            setOtherVaccination('');
            setError('');
        } else {
            let updated = [...vaccinations];

            if (updated.includes(label)) {
                updated = updated.filter(item => item !== label);
            } else {
                // Remove "None of the above" if another option is selected
                updated = [...updated.filter(item => item !== 'None of the above'), label];
            }

            setVaccinations(updated);
        }
    };

    const handleContinue = () => {
        if (vaccinations.includes('Other') && !otherVaccination.trim()) {
            setError('Please specify your other relevant vaccinations.');
            return;
        }

        setError('');
        onNext({ vaccinations, otherVaccination });
    };

    const isFormValid =
        !vaccinations.includes('Other') || (vaccinations.includes('Other') && otherVaccination.trim());

    return (
        <div className="step-form">
            <h6 className="mb-4">Immunisation & Infection Risk</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <p>
                Have you received the following vaccinations?{' '}
                <span className="text-danger">*</span>
            </p>

            <div className="row">
                {vaccinationOptions.map((label, index) => (
                    <div className="col-lg-6" key={index}>
                        <div className="form-check mb-2">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id={`vaccination-${index}`}
                                checked={vaccinations.includes(label)}
                                onChange={() => toggleVaccination(label)}
                            />
                            <label className="form-check-label" htmlFor={`vaccination-${index}`}>
                                {label}
                            </label>
                        </div>
                    </div>
                ))}
            </div>

            {vaccinations.includes('Other') && (
                <div className="mb-3 mt-3">
                    <label className="form-label">Other relevant vaccinations:</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Please specify"
                        value={otherVaccination}
                        onChange={e => setOtherVaccination(e.target.value)}
                    />
                </div>
            )}

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!isFormValid}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default StepEight;
